module.exports = __webpack_public_path__ + "static/media/coracao-garante.02133c94.svg";